export default "__VITE_ASSET__CvfozG64__"